export default __webpack_public_path__ + "static/media/s4img3.ac1549fa.webp";